<div class="copo-header">
	<div mat-dialog-title class="copo-popup-header-msg" translate> need4steel-product-details.header-msg<span translate>
			arcelormittal.need4steel.entry</span></div>
	<button type="button" mat-icon-button class="delete-icon" [mat-dialog-close]="true"><mat-icon class="close-icon" svgIcon="md:close"></mat-icon>
	</button>
</div>
<mat-dialog-content>
<div class="card-content-block">
	<div class="card-contents-infos width-content" *ngFor="let entry of getProductDataMap(); let i=index">
		<div class="card-content-info" >
			<div class="card-content-label">{{entry[1].label}}</div>
			<div *ngIf="!entry[1].isNumeric" [ngClass]="{'card-content-value-data': entry[1].fontType==='Bold'}" 
			class="card-content-value width-content">
				<ng-container *ngIf="entry[1].value && entry[1].value !== ''; else noneValue">
					{{ entry[1].value }}
				</ng-container>
				<!-- None -->
				<ng-template #noneValue>
					<ng-container *ngIf="entry[0] === 'additionalTest'">
						<span translate>fastlane.itemlist.product.coil_axis.default</span>
					</ng-container>
				</ng-template>
			</div>
			<div  *ngIf="entry[1].isNumeric" [ngClass]="{'card-content-value-data': entry[1].fontType==='Bold'}" 
			class="card-content-value width-content">
				{{toNumber(entry[1].value)| copoNumber: 'amount' : '' }}
		</div>
		</div>
		<div *ngIf="(i+1)%3===0" class="row-break"></div>
	</div>
</div>
<div class="copo-price">
	<div class="copo-proposed-price" translate>need4steel-product-details.proposed-price</div>
	<div class="copo-total-price">{{getTotalPrice()}} <span translate>need4steel-product-details.effectivedelivered</span></div>
</div>
</mat-dialog-content>